import { createUseParams as commonCreateUseParams } from '@provider-portal/common/utils/createUseParams';

/**
 * @deprecated Use createUseParams from common/utils
 */
export const createUseParams = commonCreateUseParams;
